import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Facebook, Instagram, Linkedin } from 'lucide-react';
import Logo from '../assets/logo.0d1eb692.svg';
import MastercardIcon from '../assets/mastercard.svg';
import PaypalIcon from '../assets/paypal.svg';
import VisaIcon from '../assets/visa.svg';
import AmexIcon from '../assets/aec.png';

const Footer: React.FC = () => {
  const quickLinks = [
    { name: 'Book Now', href: '/book-now' },
    { name: 'Contact', href: '/contact' },
    { name: 'Fees', href: '/fees' },
    { name: 'How To Pay', href: '/how-to-pay' },
    { name: 'Keep You Safe', href: '/keeping-you-safe' },
    { name: 'New Hope Service', href: '/new-hope-service' },
    { name: 'Terms & Conditions', href: '/terms-and-conditions' },
    { name: 'Privacy Policy', href: '/privacy-policy' },
    { name: 'External Links', href: '/external-links' },
    { name: 'Gift Vouchers', href: '/gift-vouchers' }
  ];

  return (
    <footer className="bg-slate-700 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          
          {/* Logo and Company Info */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-3">
              <img src={Logo} alt="HealthCity Logo" className="h-16 w-auto" />
            </Link>
          </div>

          {/* Quick Links - Single Column */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4">Quick Links</h3>
            <div className="flex flex-col gap-2">
              {quickLinks.map((link, index) => (
                <Link
                  key={index}
                  to={link.href}
                  className="text-gray-300 hover:text-white transition-colors text-sm"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-white" />
                <a href="tel:03338003006" className="text-gray-300 hover:text-white transition-colors">
                  0333 800 3006
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-white" />
                <a href="tel:03337890012" className="text-gray-300 hover:text-white transition-colors">
                  0333 789 0012
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-white" />
                <a href="mailto:info@healthcity.org.uk" className="text-gray-300 hover:text-white transition-colors">
                  info@healthcity.org.uk
                </a>
              </div>
            </div>
          </div>

          {/* Payment Methods and Social Media */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4">Payment & Follow Us</h3>
            
            {/* Payment Methods */}
            <div className="mb-6">
              <h4 className="text-sm font-semibold text-white mb-3">Payment Methods</h4>
              <div className="flex gap-2">
                <img src={VisaIcon} alt="Visa" className="h-6" />
                <img src={MastercardIcon} alt="Mastercard" className="h-6" />
                <img src={PaypalIcon} alt="PayPal" className="h-6" />
                <img src={AmexIcon} alt="American Express" className="h-6" />
              </div>
            </div>

            {/* Social Media Icons */}
            <div>
              <h4 className="text-sm font-semibold text-white mb-3">Follow Us</h4>
              <div className="flex gap-3">
                <a
                  href="https://www.facebook.com/HealthCityandTwinBrain"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-slate-800 p-2 rounded-full hover:bg-blue-600 transition-colors"
                >
                  <Facebook className="h-5 w-5 text-gray-300 hover:text-white" />
                </a>
                <a
                  href="https://www.instagram.com/healthcityandtwinbrain"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-slate-800 p-2 rounded-full hover:bg-pink-600 transition-colors"
                >
                  <Instagram className="h-5 w-5 text-gray-300 hover:text-white" />
                </a>
                <a
                  href="https://www.linkedin.com/company/healthcityandtwinbrain"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-slate-800 p-2 rounded-full hover:bg-blue-700 transition-colors"
                >
                  <Linkedin className="h-5 w-5 text-gray-300 hover:text-white" />
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Copyright Bar */}
      <div className="border-t border-slate-600">
        <div className="max-w-7xl mx-auto px-4 py-4 text-center">
          <p className="text-sm text-gray-400">
            Copyright © 2023. All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;